module.exports = __webpack_public_path__ + "static/keyboardshortcut-organization-do-aca156e8dea19c76c939e59a322d7b35.png";